import React from 'react';
import Pledges_title from '../../components/pledges/pledges_title';
import Positions from '../../components/pledges/positions';
import Meta from '../../components/Meta';
import {generalContent} from "../../content/generalContent";

const Pledges = () => {
	return (
		<div className="mt-[95px]">
			<Meta title={generalContent.registryName} />
			<Pledges_title />
			<Positions />
		</div>
	);
};

export default Pledges;
